import operationalProcess from './operational-process.json';

export const POSITIONING_PROMISE = 'Atiende a tus clientes y se ocupa de sus gestiones';

export const POSITIONING = {
  category: 'Tu empleado digital con IA para el día a día',
  promiseLead: 'Atiende a tus clientes',
  promiseAction: 'y se ocupa de sus gestiones',
  promise: POSITIONING_PROMISE,
  definition:
    'Áncora es una capa operativa modular de IA conectada a los canales y sistemas del negocio.',
  differentiator:
    'Tu software organiza la información. Áncora conversa y actúa sobre esa operativa.',
  integrationDisclaimer: 'La conexión se diseña alrededor de tu proceso y se activa por fases.',
  supervision:
    'Las acciones sensibles mantienen supervisión humana y se derivan al equipo cuando hace falta criterio.',
  primaryCta: 'Cuéntanos qué sistema utilizas',
  secondaryCta: 'Ver cómo avanza una gestión',
  process: operationalProcess,
  implementation: [
    'Diagnóstico del proceso prioritario',
    'Primer flujo acotado',
    'Integración y pruebas',
    'Activación y medición',
    'Ampliación por fases',
  ],
} as const;

export const UNSUPPORTED_COMMERCIAL_PHRASES = [
  'sin intervención humana',
  'todo funciona solo',
  'cualquier software se conecta',
  'setup gratis',
  'sin preguntas',
  '100% compliance',
] as const;

export type OperationalProcessStep = (typeof POSITIONING.process)[number];
